export default __webpack_public_path__ + "static/media/wilder_bild_1_mobile.5fd58c99.jpg";